import { AfterViewInit, Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-custom-scroll-bar',
  templateUrl: './custom-scroll-bar.component.html',
  styleUrls: ['./custom-scroll-bar.component.scss']
})
export class CustomScrollBarComponent implements AfterViewInit {

  @Input() scrollContainer!: HTMLElement;  // The container that we want to scroll

  thumbWidth: number = 0;
  maxScrollLeft: number = 0;

  constructor(private elementRef: ElementRef) {}

  ngAfterViewInit() {
    if (this.scrollContainer) {
      this.calculateThumbWidth();
      //this.maxScrollLeft = (this.scrollContainer.scrollWidth *.4) - this.scrollContainer.clientWidth;
      this.maxScrollLeft = 1500; //testing hard coded
      this.scrollContainer.addEventListener('scroll', this.onScroll.bind(this));
    }
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.calculateThumbWidth();
  }

  private calculateThumbWidth() {
    if (this.scrollContainer) {
      const containerWidth = this.scrollContainer.clientWidth;
      const scrollWidth = this.scrollContainer.scrollWidth;
      this.thumbWidth = (containerWidth / scrollWidth) * 100;
    }
  }

  onScroll() {
    if (this.scrollContainer) {
      const scrollLeft = this.scrollContainer.scrollLeft;
      const scrollPercentage = (scrollLeft / this.maxScrollLeft) * 100;
      this.elementRef.nativeElement.querySelector('.custom-scrollbar-thumb').style.transform = `translateX(${scrollPercentage}%)`;
    }
  }

  onThumbDrag(event: MouseEvent) {
    const scrollbar = this.elementRef.nativeElement.querySelector('.custom-scrollbar');
    const startX = event.clientX;
    const startScrollLeft = this.scrollContainer.scrollLeft;
    const thumb = this.elementRef.nativeElement.querySelector('.custom-scrollbar-thumb');
    const thumbRect = thumb.getBoundingClientRect();

    const onMouseMove = (moveEvent: MouseEvent) => {
      const deltaX = moveEvent.clientX - startX;
      const scrollDelta = (deltaX / thumbRect.width) * this.maxScrollLeft;
      this.scrollContainer.scrollLeft = startScrollLeft + scrollDelta;
    };

    const onMouseUp = () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);

    event.preventDefault();  // Prevent text selection
  }
}
